<template>
    <section class="scrollama_container_safari">
        <h3 class="scrollama_title_safari">L'estimation du montant de la fraude</h3>
        <Scrollama @step-enter="stepEnterHandler"  :offset="0.6" :progress="true" id="1" v-if="desktop">
            <div slot="graphic" class="graphic_safari" id="my-svg">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 800">
                    <title>graph_patates</title>
                    <g id="patates">
                        <rect class="cls-1" x="117.8079" y="61.6227" width="1004.4705" height="678.9009"/>
                        <g id="traits">
                            <line id="trait_1" class="cls-2" x1="491.4073" y1="402.6409" x2="376.7681" y2="529.1865"/>
                            <line id="trait_2" class="cls-2" x1="586.8481" y1="396.5475" x2="651.0567" y2="471.0555"/>
                        </g>
                        <g id="_5_5m" data-name="5_5m">
                            <g>
                                <path class="cls-3" d="M551.769,446.5135A126.2568,126.2568,0,1,1,678.0258,320.2566,126.4,126.4,0,0,1,551.769,446.5135Z"/>
                                <path class="cls-4" d="M551.7692,194.25a126.0071,126.0071,0,1,1-89.1,36.9065,125.1814,125.1814,0,0,1,89.1-36.9065m0-.5A126.5068,126.5068,0,1,0,678.2761,320.2566,126.5069,126.5069,0,0,0,551.7692,193.75Z"/>
                            </g>
                            <text class="cls-5" transform="translate(653.4125 134.6233)">Montant total<tspan x="-31.6211" y="24">estimé de la fraude :</tspan><tspan class="cls-6"><tspan x="-20.2583" y="55.2002">5,5 milliards €</tspan></tspan></text>
                        </g>
                        <g id="_4_5m" data-name="4_5m">
                            <circle class="cls-7" cx="717.8801" cy="551.3189" r="103.5055"/>
                            <text class="cls-8" transform="translate(820.7868 454.7981)">dont 4,5 milliards €<tspan class="cls-9"><tspan x="0" y="24"> </tspan><tspan class="cls-10" x="5.0588" y="24" xml:space="preserve">entre 2010  et mi-2016</tspan></tspan></text>
                        </g>
                        <g id="_1_m" data-name="1_m">
                            <text class="cls-8" transform="translate(248.312 618.3841)">dont 1 milliard €<tspan class="cls-10"><tspan x="-17.7285" y="24">entre mi-2017 et mi-2019</tspan></tspan></text>
                            <circle class="cls-7" cx="360.2212" cy="546.4962" r="23.0012"/>
                        </g>
                    </g>
                </svg>
            </div>

            <div class="step1_safari steps_safari" data-step="a">
                <article class="scrollama_safari">
                    <p>Deux études ont été menées pour connaître l’ampleur de la fraude. Elles chiffrent les pertes à plus de <strong>5,5 Mds €</strong> depuis 2010.</p>
                </article>
            </div>
            <div class="step2_safari steps_safari" data-step="b">
                <article class="scrollama_safari">
                    <p>La première étude a été réalisée en 2016. En se basant sur les dossiers en cours d’instruction, le parquet de Paris chiffrait le montant du préjudice à 4,5 Mds € sur la période 2010/2016.</p>
                </article>
            </div>
            <div class="step3_safari steps_safari" data-step="c">
                <article class="scrollama_safari">
                    <p>La seconde a été menée entre l’été 2017 et la mi-2019 par l’Autorité des marchés financiers (AMF). Ce sondage évaluait les pertes sur la période à 1 Md €.</p>
                </article>
            </div>
            <div class="step4_safari steps_safari" data-step="d">
                <article class="scrollama_safari">
                    <p>Il n’existe pas de données robustes sur le nombre de victimes. Seul un sondage, mené par en 2016 par l’institut CSA, relève que 5 % des Français interrogés auraient perdu de l’argent à cause de ce type d’arnaques.</p>
                </article>
            </div>
            <div class="step5_safari steps_safari" data-step="e">
                <article class="scrollama_safari">
                    <p>L’AMF en conclut que : <br/><strong>« plusieurs centaines de milliers de Français pourraient avoir été victimes d’une escroquerie à l’investissement ».</strong></p>
                </article>
            </div>



        </Scrollama>


        <div v-else>
            <div class="scrollama_container_safari_mobile">
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 800">
                            <title>graph_patates</title>
                            <g id="patates">
                                <rect class="cls-1" x="117.8079" y="61.6227" width="1004.4705" height="678.9009"/>
                                <g id="traits">
                                    <line id="trait_1" class="cls-2" x1="491.4073" y1="402.6409" x2="376.7681" y2="529.1865"/>
                                    <line id="trait_2" class="cls-2" x1="586.8481" y1="396.5475" x2="651.0567" y2="471.0555"/>
                                </g>
                                <g id="_5_5m" data-name="5_5m">
                                    <g>
                                        <path class="cls-3" d="M551.769,446.5135A126.2568,126.2568,0,1,1,678.0258,320.2566,126.4,126.4,0,0,1,551.769,446.5135Z"/>
                                        <path class="cls-4" d="M551.7692,194.25a126.0071,126.0071,0,1,1-89.1,36.9065,125.1814,125.1814,0,0,1,89.1-36.9065m0-.5A126.5068,126.5068,0,1,0,678.2761,320.2566,126.5069,126.5069,0,0,0,551.7692,193.75Z"/>
                                    </g>
                                    <text class="cls-5" transform="translate(653.4125 134.6233)">Montant total<tspan x="-31.6211" y="24">estimé de la fraude :</tspan><tspan class="cls-6"><tspan x="-20.2583" y="55.2002">5,5 milliards €</tspan></tspan></text>
                                </g>
                                <g id="_4_5m" data-name="4_5m">
                                    <circle class="cls-7" cx="717.8801" cy="551.3189" r="103.5055"/>
                                    <text class="cls-8" transform="translate(820.7868 454.7981)">dont 4,5 milliards €<tspan class="cls-9"><tspan x="0" y="24"> </tspan><tspan class="cls-10" x="5.0588" y="24" xml:space="preserve">entre 2010  et mi-2016</tspan></tspan></text>
                                </g>
                                <g id="_1_m" data-name="1_m">
                                    <text class="cls-8" transform="translate(248.312 618.3841)">dont 1 milliard €<tspan class="cls-10"><tspan x="-17.7285" y="24">entre mi-2017 et mi-2019</tspan></tspan></text>
                                    <circle class="cls-7" cx="360.2212" cy="546.4962" r="23.0012"/>
                                </g>
                            </g>
                        </svg>
                <div class="srollama_safari_bloc_texte">
                    <p>Deux études ont été menées pour connaître l’ampleur de la fraude. Elles chiffrent les pertes à plus de <strong>5,5 Mds €</strong> depuis 2010. La première étude a été réalisée par le parquet de Paris et chiffre le montant du préjudice à 4,5 Mds € sur la période 2010/2016. La seconde a été menée entre l’été 2017 et la mi-2019 par l’Autorité des marchés financiers (AMF) et évaluait les pertes sur la période à 1 Md €.</p>
                    <p>Il n’existe pas de données robustes sur le nombre de victimes. Seul un sondage, mené par en 2016 par l’institut CSA, relève que 5 % des Français interrogés auraient perdu de l’argent à cause de ce type d’arnaques.</p>
               <p>L’AMF en conclut que : <br/><strong>« plusieurs centaines de milliers de Français pourraient avoir été victimes d’une escroquerie à l’investissement ».</strong></p>
                </div>



            </div>
        </div>
 </section>


</template>

<script>
    import "intersection-observer"; // for cross-browser support
    import Scrollama from "vue-scrollama";

    export default {
        components: {
            Scrollama
        },
        data: function(){
            return{
                desktop:false,

              }
        },
        mounted: function() {
        if( window.innerWidth > 440){
            this.desktop = true
        }
       },

        methods: {
            stepEnterHandler({ element, index, direction }) {
                // handle the step-event as required here
                console.log(element, index, direction);

                /* declaration of the bubble*/
                var bubble_4M = document.getElementById("_4_5m");
                var bubble_1M = document.getElementById("_1_m");
                var trait_1 = document.getElementById("trait_1");
                var trait_2 = document.getElementById("trait_2");

                if (index == 0) {
                    bubble_4M.classList.toggle("turnOff")
                    bubble_1M.classList.toggle("turnOff")
                    trait_1.classList.toggle("turnOff")
                    trait_2.classList.toggle("turnOff")
                } else if (index == 1) {
                    bubble_4M.classList.toggle("turnOff");
                    trait_2.classList.toggle("turnOff");
                } else if (index == 2)  {
                    trait_1.classList.toggle("turnOff");
                    bubble_1M.classList.toggle("turnOff")
                }
            }
        }
    };
</script>
<style>


article.scrollama_safari{
        background-color:rgba(255, 255, 255, 0.8);
        text-align:center;
    }




    /*-----ecrsament du style par default---*/

    #scrollama-container-1{
        position:relative;
        top:0;
        margin:0;




    }

    /* ---- injection de mon css-----*/

    .scrollama_container_safari{
        position:relative;
        display:flex;
        flex-direction:column;
        justify-content:space-around;
        align-items:center;
        height:100%;
        width:100vw;

    }



/* on joue sur le smargin des steps pour espacer les étapes du crsollitellinhg*/

    .steps_safari {

        position:relative;
        z-index:20;
        padding: 2%;
        margin-top: 5%;
        background-color:rgba(255, 255, 255, 1);
        margin-left:0;
        left : 20%;
    }

    .step1_safari {
        width: 30%;
        margin-left:auto;
        margin-right:auto;
        margin-bottom: 30%;
    }
    .step2_safari {
        width: 30%;
        margin-left: auto;
        margin-right: auto;
        margin-bottom:20%;
    }
    .step3_safari {
        width: 30%;
        margin-left:auto;
        margin-right:auto;
    }
    .step4_safari{
        width: 30%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50%;
        margin-bottom:30%;

    }

/* c'est le margin bottom du dernier step qui débloque le sticky du graphic*/
    .step5_safari{
        width: 30%;
        margin-left: auto;
        margin-right: auto;
        margin-bottom:30%;
    }




    /*--------- CSS EXTARIT DU CSV ------*/

    .scrollama_title_safari{
        margin:0;
    }


    .cls-1 {
        fill: #fff;
    }

    .cls-2 {
        fill: none;
        stroke: gray;
        stroke-miterlimit: 10;
    }

    .cls-3 {
        fill: #1f5d9b;
    }

    .cls-4 {
        fill: #f2f2f2;
    }

    .cls-5, .cls-9 {
        font-size: 12px;
    }

    .cls-5, .cls-8 {
        fill: gray;
        font-family: OpenSans-SemiBold, Open Sans;
        font-weight: 700;
    }

    .cls-6, .cls-8 {
        font-size: 16px;
    }

    .cls-7 {
        fill: #94c3dd;
        fill-opacity: 0.9;
        stroke: #fff;
        stroke-width: 0.5px;
    }


    .turnOff{
        opacity: 0;
    }

    .reinitPotatoes{
        opacity: 1;
    }
</style>
<style scoped>

/*on cible ici spécifiquement pour safari le grpahic de crollama => deplacement vers la gauche*/
.graphic_safari{
    position:relative;
    bottom:5vh;
    padding-top:10%;
    height:70%;
    width:60%;
    right:0;
}


.srollama_safari_bloc_texte{
    position:relative;
    width:90vw;
    margin-right:5vw;
    margin-left:auto;
    height:50vh;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    align-items:center;

}

@media screen and (max-width:1000px){
    .graphic_safari{
        position:relative;
        height:100%;
        padding-top:0;
        width:100vw;
        transform:translateX(-15vw);
        right:0;
        bottom:0;
    }

    .steps_safari {

        position:relative;
        z-index:20;
        padding: 0%;
        margin-top:0%;
        background-color:rgba(255, 255, 255, 1);
        margin-left:0;
        left:67%;

    }
    .step1_safari {
        width: 25vw;
        margin-left:0;
        margin-right:0;
        margin-bottom:20%;
    }
    .step2_safari {
        width: 25vw;
        margin-left:0;
        margin-right:0;
        margin-bottom:20%;
    }
    .step3_safari {
        width:25vw;
        margin-left:0;
        margin-right:0;
    }
    .step4_safari{
        width:25vw;
        margin-left:0;
        margin-right:0;
        margin-top: 20%;
        margin-bottom:10%;

    }

    /* c'est le margin bottom du dernier step qui débloque le sticky du graphic*/
    .step5_safari{
        width: 25vw;
        margin-left: 0;
        margin-right: 0;
        margin-bottom:20%;
    }

}

</style>
